import ApplicationController from 'auth/controllers/application';

let Controllers = {
};

export function getClassByName(controllerName) {
  return Controllers[controllerName] || ApplicationController;
}
